/**
 * Checking if Rich Text is filled in, otherwise Kontent return as value '<p><br></p>'
 */

const isRichTextValid = (value?: string): value is string =>
  typeof value === 'string' && value !== '<p><br></p>';

export default isRichTextValid;
